import type {
  FormInputControl,
  FormSelectControl,
  FormOriginControl,
  FormSelectLocalControl,
  KycPersonalDetailsType,
  KycPersonalDetailsControlType,
  FormCheckboxControl,
} from 'src/types/form-config';

import { getFormDataLimit } from '../../../utils';

import { KycProps } from '../../../constants/kyc';

const employerName: FormInputControl = {
  tag: 'input',
  placeholder: 'business employer name',
  name: KycProps.EMPLOYER_NAME,
  type: 'text',
  label: 'Business Employer Name',
  validator: 'required=true, min=2, max=50, string=true',
};

const natureofbusiness: FormSelectControl = {
  tag: 'select',
  placeholder: 'nature of business',
  name: KycProps.NATURE_BUSINESS,
  type: 'text',
  label: 'Nature of Business',
  options: [],
  validator: 'required=true',
  remoteOption: true,
  optionCategory: 'NATURE_OF_BUSINESS',
  optionGetter: 'getOptions',
};

const office_address: FormInputControl = {
  tag: 'input',
  placeholder: 'office address',
  name: KycProps.ADDRESS_OFFICE,
  type: 'text',
  label: 'Address',
  validator: 'required=true, min=2, max=50, string=true',
};

const origin: FormOriginControl = {
  // tag: 'originTwo',
  tag: 'origin',
  controls: {
    country: {
      tag: 'select',
      placeholder: 'country',
      name: KycProps.COUNTRY_OFFICE,
      type: 'text',
      label: 'Country',
      options: [],
      validator: 'required=true',
      remoteOption: true,
      optionCategory: 'COUNTRY',
      optionGetter: 'getOptionsAddress',
    } as FormSelectControl,
    province: {
      tag: 'select',
      placeholder: 'province',
      name: KycProps.PROVINCE_OFFICE,
      type: 'text',
      label: 'Province',
      options: [],
      validator: 'required=true',
      remoteOption: true,
      optionCategory: 'PROVINCE',
      optionGetter: 'getOptionsAddress',
    } as FormSelectControl,
    city: {
      tag: 'select',
      placeholder: 'city',
      name: KycProps.CITY_OFFICE,
      type: 'text',
      label: 'City',
      options: [],
      validator: 'required=true',
      remoteOption: true,
      optionCategory: 'CITY',
      optionGetter: 'getOptionsAddress',
    } as FormSelectControl,
  },
};

const postalCode: FormInputControl = {
  tag: 'input',
  placeholder: 'postal code',
  name: KycProps.POSTAL_OFFICE,
  type: 'text',
  label: 'Postal Code',
  validator: 'required=true, max=10, min=2, number=true',
};

const officePhone: FormInputControl = {
  tag: 'input',
  placeholder: 'phone',
  name: KycProps.PHONE_OFFICE,
  type: 'text',
  label: 'Phone',
  validator: 'required=true, max=50, min=2, string=true',
};
const officeFax: FormInputControl = {
  tag: 'input',
  placeholder: 'fax',
  name: KycProps.FAX_OFFICE,
  type: 'text',
  label: 'Fax',
  validator: 'required=true, max=50, min=2, string=true',
};

const shareholder: FormSelectLocalControl = {
  tag: 'select',
  placeholder: 'shareholder',
  name: KycProps.SHAREHOLDER,
  type: 'text',
  label:
    'Are you a director, officer or shareholder in any organization outside of your main employer?',
  options: [
    { value: false, display: 'No' },
    { value: true, display: 'Yes' },
  ],
  validator: 'required=true',
};

const sameHomeAddress: FormCheckboxControl = {
  tag: 'address-checkbox',
  name: KycProps.IS_SAME_ADDRESS,
  type: 'checkbox',
  options: [{ value: false, display: 'Same as home address', key: 1 }],
  value: '',
};

const controls: KycPersonalDetailsControlType = [
  sameHomeAddress,
  employerName,
  natureofbusiness,
  office_address,
  origin,
  postalCode,
  officePhone,
  officeFax,
  shareholder,
];

const KycPersonalDetailsData: KycPersonalDetailsType = {
  name: 'professional_details',
  display: 'Professional Details',
  controls,
  getFormData: getFormDataLimit(controls),
};

export default KycPersonalDetailsData;
